import { styled } from '@mui/material';
import EmailSentConfirmation from 'components/ForgotPassword/EmailSentConfirmation';
import NewPassword from 'components/ForgotPassword/NewPassword';
import ResetPasswordPage from 'components/ForgotPassword/ResetPasswordPage';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/ForgotPassword/PageProvider';
import { useContext } from 'react';
import { Box, Container, Copyright, Icon, Logo, Stack } from 'shell/components';

const Desktop = () => {
    const { device } = useViewport();
    const {
        currentStep,
        errors,
        form,
        satisfyRequirement,
        handleSendForgotPasswordCode,
        handleResendCode,
        handleUpdatePassword,
        handleChange,
        PAGES,
    } = useContext(PageContext);

    return (
        <Container device={'desktop'} sx={{ height: '100%', pb: 3 }}>
            <CenterBox>
                <Stack alignItems={'center'} spacing={2}>
                    <CustomIcon kind={'ensightful'} />
                    <Logo device={'desktop'} />
                </Stack>
                {currentStep === PAGES.ENTER_EMAIL && (
                    <ResetPasswordPage
                        device={device}
                        errors={errors}
                        form={form}
                        handleChange={handleChange}
                        handleSendForgotPasswordCode={handleSendForgotPasswordCode}
                    />
                )}
                {currentStep === PAGES.EMAIL_SENT && (
                    <EmailSentConfirmation device={device} form={form} handleResendCode={handleResendCode} />
                )}
                {currentStep === PAGES.NEW_PASSWORD && (
                    <NewPassword
                        device={device}
                        errors={errors}
                        form={form}
                        satisfyRequirement={satisfyRequirement}
                        handleChange={handleChange}
                        handleUpdatePassword={handleUpdatePassword}
                    />
                )}
            </CenterBox>
            <Copyright />
        </Container>
    );
};

const CenterBox = styled(Box)(({ theme }) => {
    return {
        zIndex: 10,
        paddingTop: theme.spacing(18),
        width: 'fit-content',
        height: '100%',
    };
});

const CustomIcon = styled(Icon)(() => {
    return {
        fontSize: '1.5rem',
    };
});

export default Desktop;
